<template>
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="14px" height="20px"
    viewBox="0 0 66 80" xml:space="preserve">
    <path fill="currentColor" d="M60.31,76.61H6.79c-2.23,0-4.03-1.8-4.03-4.03c0-2.23,1.8-4.03,4.03-4.03h53.52c2.23,0,4.03,1.8,4.03,4.03
      C64.34,74.81,62.54,76.61,60.31,76.61z M35.15,64.28l28.42-25.42c0.64-0.65,0.83-1.61,0.49-2.45c-0.35-0.84-1.17-1.39-2.08-1.39
      h-12.5V5.95c0-1.24-1.01-2.25-2.25-2.25H19.88c-1.24,0-2.25,1.01-2.25,2.25v29.07H5.13c-0.91,0-1.73,0.55-2.08,1.39
      s-0.15,1.81,0.49,2.45l28.42,25.42c0.42,0.42,0.99,0.66,1.59,0.66C34.15,64.93,34.72,64.7,35.15,64.28z"/>
  </svg>
</template>
